import { theme } from 'antd';

const primaryOrange = '#F97316';
const pageBg = '#F1F5F9';
const cardBg = '#FFFFFF';
const sidebarBg = '#FFFFFF';
const textPrimary = '#1E293B';
const textSecondary = '#64748B';
const border = '#E2E8F0';

export const darkOrangeTheme = {
  token: {
    colorPrimary: primaryOrange,
    colorBgBase: pageBg,
    colorTextBase: textPrimary,
    colorBorder: border,
    colorBgContainer: cardBg,
    colorBgElevated: cardBg,
    borderRadius: 6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  algorithm: theme.defaultAlgorithm,
};

export const themeColors = {
  primary: primaryOrange,
  success: '#22C55E',
  warning: '#EAB308',
  error: '#EF4444',
  info: '#3B82F6',
  text: textPrimary,
  textSecondary: textSecondary,
  border,
  bg: pageBg,
  bgElevated: cardBg,
  sidebarBg,
  sidebarBorder: border,
  sidebarText: textPrimary,
};
